import { render, staticRenderFns } from "./PrestationModal.vue?vue&type=template&id=124e200a"
import script from "./PrestationModal.vue?vue&type=script&lang=js"
export * from "./PrestationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports